import * as React from 'react';

import PropTypes from 'prop-types';
import { Modal, Button } from 'semantic-ui-react';

import BlueButton from '../../BlueButton'; 
import styles from './CreateUserModal.module.css';

function CreateUserModal({ visibility, onOpenModal, onCloseModal }) {

  return (
    <Modal
      size="small"
      centered
      open={visibility}
      onOpen={onOpenModal}
      onClose={onCloseModal}
    >
      <div className={styles.modalContainer}>
        <Button
          className={styles.closeButton}
          onClick={onCloseModal}
          size="big"
          icon="close"
        />
        <text className={styles.headerText}>
          New user created! Their user login details will be sent to the email provided.
        </text>

        <BlueButton
          className={styles.saveButton}
          buttonText="Ok"
          onClick={onCloseModal}
        />

      </div>

    </Modal>
  );
}

CreateUserModal.propTypes = {
  visibility: PropTypes.bool.isRequired,
  onOpenModal: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
};

export default CreateUserModal;
